import * as types from '../mutations-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  org_pop_event: {}
}

// actions
const actions = {}

// mutations
const mutations = {
  [types.ORG_POP_EVENT](state, data) {
    state.org_pop_event = data
  }
}
// getters
const getters = {}

export default {
  state,
  getters,
  actions,
  mutations
}
